import i18n from 'modules/core/lib/i18n'

import { FrequencyOptions } from 'modules/surveys/lib/enums'

export const DEFAULT_FREQUENCY_OPTION: FrequencyOptions = 'monthly'

export const frequencyOptionLabel = (): Map<FrequencyOptions, string> =>
  new Map([
    ['daily', i18n.t('surveys.form.periodicity.daily')],
    ['weekly', i18n.t('surveys.form.periodicity.weekly')],
    ['bi_weekly', i18n.t('surveys.form.periodicity.bi_weekly')],
    ['monthly', i18n.t('surveys.form.periodicity.monthly')],
    ['bi_monthly', i18n.t('surveys.form.periodicity.bi_monthly')],
    ['quarterly', i18n.t('surveys.form.periodicity.quarterly')],
    ['quadrimester', i18n.t('surveys.form.periodicity.quadrimester')],
    ['semiannual', i18n.t('surveys.form.periodicity.semiannual')],
    ['annual', i18n.t('surveys.form.periodicity.yearly')],
  ])

const cycleOptionsAvailable: FrequencyOptions[] = [
  'daily',
  'weekly',
  'bi_weekly',
  'monthly',
  'bi_monthly',
  'quarterly',
  'quadrimester',
  'semiannual',
  'annual',
]

export const frequencySelectOptions = () => {
  const options: { value: FrequencyOptions; label: string }[] = []
  cycleOptionsAvailable.forEach((frequency) => {
    options.push({
      value: frequency,
      label: frequencyOptionLabel().get(frequency) ?? '',
    })
  })
  return options
}
